
import { Seo } from '../layouts/Seo';
import {VirtualOfficeExplorer} from '../comp/OfficeExplorer'

const VirtualOfficePage = () => {
    return (
    <>


  <Seo
        title="About Saigon A.I. - Virtual Office Explorer"
        description="Beep. "
        type="webapp"
      />

    <div class="breadcrumb">
        <span class="caret">&gt;</span>
        <span class="current">About Us</span>
        <span class="caret">&gt;</span>
        <span class="current">Virtual Office</span>
    </div>

    <VirtualOfficeExplorer />

    </>
    )
  };
  
  export default VirtualOfficePage;